<template>
  <div class="part table customer-list">
    <keep-alive>
      <a-table
        :columns="columns"
        :dataSource="customers"
        :rowKey="(customer, index) => customer._id"
        :scroll="{ x: 1000 }"
      >
        <span slot="avatar" slot-scope="avatar">
          <a-avatar shape="square" :size="28" :src="avatar" icon="user" />
        </span>

        <span slot="fullname" slot-scope="customer">
          <span class="first_name">{{ customer.name }}</span>
          <span class="last_name ml-1" v-if="customer.last_name">{{ customer.last_name }}</span>
        </span>

        <span slot="status" slot-scope="status">
          <span class="font-size-12 badge" :class="statusClass(status)">{{ status | PROJECT_STATUS_ }}</span>
        </span>
        <span slot="note" slot-scope="note">
          <div class="sticker" v-if="note">{{ note }}</div>
          <div v-else>N/A</div>
        </span>

        <span slot="created_at" slot-scope="created_at">
          <span> {{ created_at | moment('l') }} </span>
        </span>

        <span slot="created_by" slot-scope="created_by">
          <span> {{ created_by ? created_by.display_name : '---' }} </span>
        </span>

        <span slot="actions" slot-scope="customer">
          <a-button type="primary" @click="onAddProject(customer)" size="small" icon="plus-square">Add </a-button>
          <a-button type="dashed" class="ml-1" @click="onEditCustomer(customer._id)" size="small" icon="edit">
            Edit
          </a-button>
        </span>
      </a-table>
    </keep-alive>
  </div>
</template>

<script>
// import router from '@/router'
// import { shortID } from '@/utils/formators'

export default {
  name: 'table-customers',
  props: ['customers'],
  data() {
    return {
      columns: [
        {
          title: '',
          dataIndex: 'avatar',
          key: 'avatar',
          width: 80,
          fixed: 'left',
          align: 'center',
          scopedSlots: { customRender: 'avatar' },
        },
        {
          title: 'Full Name',
          key: 'fullname',
          fixed: 'left',
          width: 120,
          scopedSlots: { customRender: 'fullname' },
        },
        {
          title: 'Status',
          dataIndex: 'status',
          key: 'status',
          align: 'center',
          width: 120,
          filters: [
            {
              text: 'Pending',
              value: 'pending',
            },
            {
              text: 'Active',
              value: 'active',
            },
            {
              text: 'Inactive',
              value: 'Inactive',
            },
          ],
          filterMultiple: false,
          onFilter: (status, customer) => customer.status.indexOf(status) === 0,
          scopedSlots: { customRender: 'status' },
        },
        {
          title: 'Phone',
          dataIndex: 'phone',
          key: 'phone',
          width: 120,
        },
        {
          title: 'Email',
          dataIndex: 'email',
          key: 'email',
          width: 180,
          ellipsis: true,
        },
        {
          title: 'WeChat',
          dataIndex: 'wechat',
          key: 'wechat',
          width: 120,
        },
        {
          title: 'Location',
          dataIndex: 'location',
          key: 'location',
          width: 150,
        },
        {
          title: this.$t('crm.list.note'),
          dataIndex: 'note',
          key: 'note',
          width: 220,
          scopedSlots: { customRender: 'note' },
        },
        {
          title: 'Created',
          dataIndex: 'created_at',
          key: 'created_at',
          width: 120,
          scopedSlots: { customRender: 'created_at' },
        },
        {
          title: 'Creator',
          dataIndex: 'created_by',
          key: 'created_by',
          width: 120,
          scopedSlots: { customRender: 'created_by' },
        },
        {
          title: 'Actions',
          key: 'actions',
          fixed: 'right',
          width: 160,
          scopedSlots: { customRender: 'actions' },
        },
      ],
    }
  },
  methods: {
    statusClass(status) {
      switch (status) {
        case 'active':
          return 'badge-primary'
        case 'inactive':
          return 'badge-danger'
        case 'pending':
          return 'badge-default'
        default:
          return 'badge-default'
      }
    },
    onAddProject(customer) {
      this.$store.dispatch('pm/setNewProjectCustomer', customer)
      this.$store.dispatch('pm/open', 'CREATE_PROJECT')
    },
    onEditCustomer(id) {
      if (id) {
        this.$router.push({ name: 'customer-detail', params: { id } })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.table.customer-list {
  .status {
    border: none;
    text-transform: capitalize;
    background: #666;
    color: #fff;
    &.active {
      background: #00b44b;
    }
  }

  .sticker {
    background: #ffeb3b;
    padding: 2px 8px;
    color: #000;
    border-radius: 3px;
    font-size: 12px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    box-shadow: 0 0 10px #eee;
  }
}
</style>
